import { useEffect, useState } from "react";
import Loader from "../../components/loader";
import Layout from "../../components/Layout";
import api from "../../utils/api";
import { errorMessage } from "../../utils/utils";
import { useParams } from "react-router-dom";
import { IoMdRefreshCircle } from "react-icons/io";
import Spinner from "../../components/spinner";
import { toast } from "react-toastify";
import moment from "moment";
import { FaEdit, FaQuestion, FaSave } from "react-icons/fa";
import { AiFillCloseSquare } from "react-icons/ai";
import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from "@headlessui/react";
import { Button, ErrorState } from '../../components/ui';
import { ListLoading } from '../../components/ListToolbar';
import { CreditsPayment, useCredits } from '../../components/Credits';

const monthly = 40;
const yearly = 360;

const ports = [
    { value: '8291', label: 'Winbox (8291)' },
    { value: '80', label: 'HTTP (80)' },
    { value: '443', label: 'HTTPS (443)' },
    { value: '22', label: 'SSH (22)' },
    { value: 'custom', label: 'Custom' },
];

export default function RemoteItem() {

    useEffect(() => {

        if (!window.localStorage.token) {
            window.location.replace('/signin');
            return;
        }

        setPageLoading(false);

        getData();

    }, []);


    const { id } = useParams();
    const [pageLoading, setPageLoading] = useState(true);

    const [dataLoading, setDataLoading] = useState(true);
    const [dataError, setDataError] = useState('');
    const [data, setData] = useState<any>();

    const [serverLoading, setServerLoading] = useState(true);
    const [servers, setServers] = useState<any>([]);
    const [services, setServices] = useState<any>([]);

    const [label, setLabel] = useState('');
    const [service, setService] = useState('');
    const [server, setServer] = useState('');
    const [app_port, setAppPort] = useState('');
    const [custom, setCustom] = useState('');
    const [protocol, setProtocol] = useState('');

    const [update, setUpdate] = useState('');
    const [updating, setUpdating] = useState(false);

    const [openDialog, setOpenDialog] = useState(false);
    const [quantity, setQuantity] = useState('1');
    const [unit, setUnit] = useState('year');
    const [expiration, setExpiration] = useState<any>();
    const [subsReq, setSubsReq] = useState(false);
    const [renewError, setRenewError] = useState('');
    const [renewLoading, setRenewLoading] = useState(false);
    const [confirmDialog, setConfirmDialog] = useState(false);

    const { balance, error: balanceError, reload: reloadCredits } = useCredits();

    async function getData() {

        setDataError('');
        setDataLoading(true);
        try {

            const res = await api.get(`/remote/${id}`);
            const json = await res.json();
            if (res.ok) {
                setData(json);
                setLabel(json.label);
                setServer(json.server);
                setService(json.service);
                setAppPort(json.app_port);
                setCustom(json.custom);
                setProtocol(json.protocol);
                getServers(json.server);
            } else {
                setServerLoading(false);
                setDataError(errorMessage(json));
            }
        } catch (error) {
            setServerLoading(false);
            setDataError(errorMessage(error));
        }

        setDataLoading(false);
    }

    async function getServers(name?: string) {
        try {
            const res = await api.get(`/remote/server`);
            const json = await res.json();
            if (res.ok) {
                setServers(json);
                if (json.length > 0) {
                    const find = json.find((item: any) => item.name === name);
                    if (find) {
                        setServices(find.services);
                    }
                }
            } else {
                toast.error(errorMessage(json));
            }
        } catch (err) {
            toast.error(errorMessage(err));
        }

        setServerLoading(false);
    }

    async function updateData() {
        if (!update) return;

        switch (update) {
            case 'label':
                if (data.label === label) return;
                break;
            case 'service':
                if (data.service === service) return;
                break;
            case 'app_port':
                if (app_port === 'custom') {
                    if (data.protocol === protocol && data.custom === custom) return;
                } else {
                    if (data.app_port === app_port) return;
                }
                break;
        }

        setUpdating(true);

        try {
            const res = await api.patch(`/remote/${id}`, { update, label, server, service, app_port, custom, protocol });
            const json = await res.json();
            if (res.ok) {
                toast.success(json.message);

                switch (update) {
                    case 'label':
                        data.label = label;
                        break;
                    case 'service':
                        data.service = service;
                        break;
                    case 'app_port':
                        data.app_port = app_port;
                        data.protocol = protocol;
                        data.custom = custom;
                        break;
                }

                startEdit('');

            } else {
                toast.error(errorMessage(json));
            }

        } catch (err) {
            toast.error(errorMessage(err));
        }

        setUpdating(false);
    }


    function getDate() {

        const date = data?.date_created ? moment(data.date_created).format('MMMM Do YYYY') : undefined;
        return date;
    }

    function getExpiration() {

        const date = data?.date_expiration ? moment(data.date_expiration).format('MMMM Do YYYY') : undefined;
        return date;
    }

    function getDaysLeft() {

        let daysLeft;

        try {
            const expDate = Date.parse(data.date_expiration?.toString());

            if (expDate) {
                const now = new Date();
                const diff = (expDate - now.getTime()) / (1000 * 60 * 60 * 24);
                daysLeft = diff.toFixed(0);
            }
        } catch (error) {

        }

        return daysLeft;
    }

    function getServerLabel() {
        let label = '';
        const find = servers.find((item: any) => item.name === data?.server);

        if (find) {
            label = find.label;
        }

        return label;
    }

    function getAppPort() {

        let label = '';

        if (data?.app_port === 'custom') {
            label = data?.protocol?.toUpperCase() + ':' + data?.custom;
        } else {
            const find = ports.find((item: any) => item.value === data?.app_port);
            if (find) {
                label = find.label;
            }
        }

        return label;
    }

    function startEdit(name: string) {
        if (updating) return;

        setLabel(data?.label);
        setServer(data?.server);
        setService(data?.service);
        setAppPort(data?.app_port);
        setCustom(data?.custom);
        setProtocol(data?.protocol);
        setUpdate(name);
    }

    function getEstimateExpirationDate(quantity: string, unit: string) {
        // var date = data?.date_expiration ? moment(data?.date_expiration).toDate() : new Date();

        const today = new Date();

        var date = data?.date_expiration ? moment(data.date_expiration).toDate() : today;

        var exp = new Date(date);

        try {
            const expDate = Date.parse(data?.date_expiration?.toString());
            if (expDate) {
                const now = new Date();
                const days = (expDate - now.getTime()) / (1000 * 60 * 60 * 24);
                if (days <= 0) {
                    exp = today;
                }
            }

        } catch (error) {
            console.log('Error date expiration:', error);
        }



        switch (unit) {
            case 'month':
                exp.setMonth(date.getMonth() + parseInt(quantity));
                break;
            case 'year':
                exp.setFullYear(date.getFullYear() + parseInt(quantity));
                break;
        }

        setExpiration(moment(exp).format('MMMM Do YYYY'));
    }

    function price() {
        const qty = parseInt(quantity);
        return (unit === 'year' ? yearly : monthly) * (isNaN(qty) ? 0 : qty);
    }

    function submit() {

        if (!quantity || !unit) {
            setSubsReq(true);
            setRenewError('Please add subscription plan');
            return;
        } else {
            setSubsReq(false);
        }

        if (balance === undefined || balance < price()) {
            setRenewError('You do not have enough credits for this renewal. Please top up your credits first.');
            return;
        }

        setRenewError('');
        setConfirmDialog(true);
    }

    async function renew() {
        setRenewLoading(true);

        try {
            const res = await api.post(`/remote/renew/${id}`, { quantity: quantity, unit: unit });
            const json = await res.json();
            if (res.ok) {
                setRenewError('');
                setOpenDialog(false);
                toast.success(json.message);
                reloadCredits();
                getData();
            } else {
                setRenewError(errorMessage(json));
            }

        } catch (error) {
            setRenewError(errorMessage(error));
        }

        setRenewLoading(false);
    }

    if (pageLoading) {
        return (<div className='w-screen h-screen text-center flex flex-col bg-white justify-center'><Loader /></div>)
    }

    let deletion = null;
    let deleteDays = null;

    if (data) {
        deletion = data?.date_delete ? moment(data?.date_delete).format('LL') : null;
        if (deletion) {
            deleteDays = moment(data.date_delete).diff(moment(new Date()), 'days');
            deleteDays = `in ${deleteDays} day${deleteDays > 1 ? 's' : ''}`
        }
    }

    return (
        <>
            <Layout nav='remote' title={`My Remote Accounts > ${data?.label ?? 'Loading...'}`}>

                    <div className="mx-auto max-w-3xl px-5 py-8 sm:px-8">

                        <button
                            type="button"
                            onClick={() => window.history.back()}
                            className="inline-flex items-center gap-1 text-sm font-semibold text-slate-400 transition hover:text-slate-950">
                            <svg viewBox="0 0 20 20" fill="currentColor" className="h-4 w-4">
                                <path fillRule="evenodd" d="M17 10a.75.75 0 0 1-.75.75H5.612l4.158 3.96a.75.75 0 1 1-1.04 1.08l-5.5-5.25a.75.75 0 0 1 0-1.08l5.5-5.25a.75.75 0 1 1 1.04 1.08L5.612 9.25H16.25A.75.75 0 0 1 17 10Z" clipRule="evenodd" />
                            </svg>
                            Go back
                        </button>

                        <h1 className="mt-4 text-2xl font-semibold tracking-tight text-slate-900 sm:text-3xl">{data?.label ?? 'Remote Account'}</h1>
                        <p className="mt-1 text-sm text-slate-500">{data?.user}</p>

                        {dataLoading && <ListLoading label='Loading account...' />}
                        {(!dataLoading && dataError) && <ErrorState error={dataError} />}

                        <div className={`mt-6 space-y-5 ${(dataLoading || !data || dataError) && 'hidden'}`}>

                            <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">

                            <h2 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-400">Account Settings</h2>

                            <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 sm:flex-row sm:items-center sm:gap-3">

                                <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Label</label>

                                <div className={`leading-none text-blue-500 ${update === 'label' && 'hidden'}`}>{data?.label}</div>

                                <div className={`${update !== 'label' && 'hidden'}`}>
                                    <input
                                        name="label"
                                        type="text"
                                        required={true}
                                        value={label}
                                        disabled={dataLoading || updating}
                                        // placeholder="Just a label for your device"
                                        className="w-full md:w-[300px] min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500"
                                        onChange={(e) => setLabel(e.target.value)}
                                    />
                                </div>

                                <FaEdit className={`ml-3 text-blue-500 w-[11px] h-[11px] cursor-pointer ${update === 'label' && 'hidden'}`} onClick={() => startEdit('label')} />

                                <div className={`flex flex-row items-center ${(update !== 'label' || updating) && 'hidden'}`}>
                                    <AiFillCloseSquare className={`ml-3 text-gray-500 w-[18px] h-[18px] cursor-pointer`} onClick={() => startEdit('')} />
                                    <FaSave className={`ml-3 text-green-500 w-[16px] h-[16px] cursor-pointer`} onClick={updateData} />
                                </div>

                                <Spinner className={`ml-3 fill-blue-500 text-blue-100 ${(update !== 'label' || !updating) && 'hidden'}`} />

                            </div>

                            <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                <label htmlFor="server" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Server</label>
                                {serverLoading && <Spinner className='ml-2' />}
                                <div className={`${update === 'server' && 'hidden'}`}>{getServerLabel()}</div>
                                <div className={`relative ${update !== 'server' && 'hidden'}`}>
                                    {serverLoading && <Spinner className='absolute ml-2 mt-[5px]' />}
                                    <select
                                        name='server'
                                        value={server}
                                        required={true}
                                        disabled={dataLoading || serverLoading || updating}
                                        className={`w-full md:w-[300px] min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500`}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (value) {
                                                const find = servers.find((item: any) => item.name === value);
                                                if (find) {
                                                    setServices(find.services);
                                                }
                                            } else {
                                                setServices([])

                                            }

                                            setServer(value);
                                        }}>
                                        {!serverLoading && <option value=''>Please select...</option>}
                                        {
                                            servers.map((item: any, index: number) => {
                                                return <option key={`${index}-server`} value={item.name} disabled={!item.enabled}>{item.label ?? item.name}{!item.enabled && ' (unavailable)'}</option>
                                            })
                                        }

                                    </select>
                                </div>

                                <div className={`flex flex-row items-center ${serverLoading && 'hidden'}`}>
                                    <FaEdit className={`ml-3 text-gray-500 w-[11px] h-[11px] ${update === 'server' && 'hidden'}`} onClick={undefined /*() => startEdit('server')*/} />
                                    <div className={`flex flex-row items-center ${(update !== 'server' || updating) && 'hidden'}`}>
                                        <AiFillCloseSquare className={`ml-3 text-gray-500 w-[18px] h-[18px]`} onClick={undefined /*() => startEdit('')*/} />
                                        <FaSave className={`ml-3 text-gray-500 w-[16px] h-[16px]`} onClick={undefined /*updateData*/} />
                                    </div>
                                    <Spinner className={`ml-3 fill-blue-500 text-blue-100 ${(update !== 'server' || !updating) && 'hidden'}`} />
                                </div>
                            </div>

                            <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                <label htmlFor="service" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Service</label>
                                <div className={`${update === 'service' && 'hidden'}`}>{data?.service?.toUpperCase()}</div>
                                <select
                                    name='service'
                                    value={service}
                                    style={{ width: "200px" }}
                                    required={true}
                                    disabled={dataLoading || !server || updating}
                                    className={`min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500 ${update !== 'service' && 'hidden'}`}
                                    onChange={(e) => setService(e.target.value)}>
                                    <option value=''>Please select...</option>
                                    {
                                        services.map((item: any, index: number) => {
                                            return <option key={`${index}-service`} value={item}>{item?.toUpperCase()}</option>
                                        })
                                    }
                                </select>
                                <FaEdit className={`ml-3 text-blue-500 w-[11px] h-[11px] cursor-pointer ${update === 'service' && 'hidden'}`} onClick={() => startEdit('service')} />
                                <div className={`flex flex-row items-center ${(update !== 'service' || updating) && 'hidden'}`}>
                                    <AiFillCloseSquare className={`ml-3 text-gray-500 w-[18px] h-[18px] cursor-pointer`} onClick={() => startEdit('')} />
                                    <FaSave className={`ml-3 text-green-500 w-[16px] h-[16px] cursor-pointer`} onClick={updateData} />
                                </div>
                                <Spinner className={`ml-3 fill-blue-500 text-blue-100 ${(update !== 'service' || !updating) && 'hidden'}`} />
                            </div>

                            <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                <label htmlFor="application" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Application</label>
                                <div className={`${update === 'app_port' && 'hidden'}`}>{getAppPort()}</div>
                                <select
                                    name='application'
                                    value={app_port}
                                    style={{ width: "200px" }}
                                    required={true}
                                    disabled={dataLoading || !server || updating}
                                    className={`min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500 ${update !== 'app_port' && 'hidden'}`}
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        if (value === 'custom') {
                                            if (!protocol) {
                                                setProtocol('tcp');
                                            }
                                        } else {
                                            setCustom('');
                                            setProtocol('');
                                        }
                                        setAppPort(value);

                                    }}>
                                    <option value=''>Please select...</option>
                                    {
                                        ports.map((item: any, index: number) => {
                                            return <option key={`${index}-port`} value={item.value}>{item.label}</option>
                                        })
                                    }
                                </select>
                                <FaEdit className={`ml-3 text-blue-500 w-[11px] h-[11px] cursor-pointer ${update === 'app_port' && 'hidden'}`} onClick={() => startEdit('app_port')} />
                                <div className={`flex flex-row items-center ${(update !== 'app_port' || updating) && 'hidden'}`}>
                                    <AiFillCloseSquare className={`ml-3 text-gray-500 w-[18px] h-[18px] cursor-pointer`} onClick={() => startEdit('')} />
                                    <FaSave className={`ml-3 text-green-500 w-[16px] h-[16px] cursor-pointer`} onClick={updateData} />
                                </div>
                                <Spinner className={`ml-3 fill-blue-500 text-blue-100 ${(update !== 'app_port' || !updating) && 'hidden'}`} />

                            </div>

                            <div className={`mt-1 mb-2 flex flex-col gap-3 ${(app_port !== 'custom' || update !== 'app_port') && 'hidden'}`}>
                                <div className="flex flex-row items-center">
                                    <label htmlFor="custom" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Port</label>
                                    <input
                                        name="custom"
                                        type="text"
                                        required={app_port === 'custom' ? true : false}
                                        value={custom}
                                        disabled={dataLoading || !server || updating}
                                        style={{ width: "200px" }}
                                        maxLength={5}
                                        placeholder="0 to 65535"
                                        className="min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500 placeholder:text-sm placeholder:text-slate-400"
                                        onChange={(e) => {
                                            const re = /^[0-9\b]+$/;
                                            if (e.target.value === '' || re.test(e.target.value)) {
                                                setCustom(e.target.value);
                                            }
                                        }}
                                    />
                                </div>

                                <div className="flex flex-row items-center">
                                    <label htmlFor="protocol" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Protocol</label>
                                    <select
                                        name='protocol'
                                        required={app_port === 'custom' ? true : false}
                                        value={protocol}
                                        disabled={dataLoading || !server || updating}
                                        style={{ width: "200px" }}
                                        className={`min-h-[38px] rounded-xl border-0 bg-slate-50 px-3 text-sm text-slate-900 ring-1 ring-inset ring-slate-200 outline-none transition focus:bg-white focus:ring-2 focus:ring-blue-500`}
                                        onChange={(e) => setProtocol(e.target.value)}>
                                        <option value=''>Please select...</option>
                                        <option value='tcp'>TCP</option>
                                        <option value='udp'>UDP</option>
                                    </select>
                                </div>
                            </div>

                            </div>

                            <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
                                <h2 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-400">Transaction History</h2>
                                <div className="hidden md:block"><Large items={data?.references ?? []} /></div>
                                <div className="md:hidden w-full"><Small items={data?.references ?? []} /></div>
                            </div>


                            <div className="rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">

                            <h2 className="mb-4 text-sm font-bold uppercase tracking-wider text-slate-400">Status &amp; Connection</h2>

                            <div>
                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Created On:</label>
                                    <div>{getDate()}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Expired On:</label>
                                    <div>{getExpiration()}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Day(s) Left:</label>
                                    <div>{getDaysLeft()}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Status:</label>
                                    <span className={`px-2 py-[1.5px] rounded-md text-white font-bold text-xs ${data?.status !== 'online' ? 'bg-gray-400' : 'bg-green-500'}`}>{data?.status}</span>
                                    <span className={`ml-1 px-2 py-[1.5px] rounded-md text-white font-bold text-xs bg-red-500 ${!data?.expired && 'hidden'}`}>expired</span>
                                </div>

                                <div className={`${data?.status !== 'online' && 'hidden'}`}>
                                    <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                        <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Up Time:</label>
                                        <div>{data?.uptime}</div>
                                    </div>

                                    <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                        <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Remote IP:</label>
                                        <div>{data?.remote_ip}</div>
                                    </div>

                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Connect To:</label>
                                    <div className="text-blue-500">{data?.from_address}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">User:</label>
                                    <div className="text-blue-500">{data?.user}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Password:</label>
                                    <div className="text-blue-500">{data?.password}</div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Remote Port:</label>
                                    <div className="text-blue-500">{data?.port}</div>

                                    <div className='group relative flex justify-center'>
                                        <IoMdRefreshCircle className={`ml-2 text-gray-500 w-[18px] h-[18px]`} onClick={() => { }} />
                                        <span className="whitespace-nowrap absolute z-10 top-10 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">Get a new remote port (Unavailable)</span>
                                    </div>
                                </div>

                                <div className="flex flex-col gap-0.5 border-b border-slate-100 py-2 last:border-0 sm:flex-row sm:items-center sm:gap-3">
                                    <label htmlFor="label" className="block shrink-0 text-xs font-semibold text-slate-400 sm:w-[130px]">Remote Url:</label>
                                    <div className="text-blue-500">{data?.from_address}:{data?.port}</div>
                                </div>


                                {(deletion || data?.warnings?.length > 0 || data?.errors?.length > 0) && <div className="mt-5 flex flex-col">

                                    {(data?.status !== 'deleted' && deletion) && <div className='leading-none text-sm text-red-500 italic'>This account will be automatically deleted on {deletion} ({deleteDays}) if not renewed</div>}
                                    
                                    {data?.errors?.length > 0 && <div className="leading-none flex flex-col">{
                                        data?.errors.map((item: any, index: number) => {
                                            return <div key={`${index}-error`} className="text-sm text-red-500 italic">{item}</div>
                                        })
                                    }</div>}

                                    {data?.warnings?.length > 0 && <div className="leading-none flex flex-col">{
                                        data?.warnings.map((item: any, index: number) => {
                                            return <div key={`${index}-warning`} className="text-sm text-orange-500 italic">{item}</div>
                                        })
                                    }</div>}
                                </div>}


                                <div className="mt-5 text-xs">Having troubles connecting? <a href={`https://kptd.ph/remote/tutorials/how-to-connect-${data?.service}-client${data?.service === 'sstp' && data?.service_port ? `?port=${data?.service_port}` : ''}`} rel="noreferrer" target='_blank' className='text-blue-500 font-medium'>click here</a> for tutorials on how to connect.</div>

                            </div>

                            </div>

                            <div className="flex flex-row gap-2 rounded-2xl border border-slate-200 bg-white p-5 sm:p-6">
                                <Button tone='ghost' onClick={() => window.history.back()}>Back</Button>
                                <div className="grow"></div>
                                <Button tone='green' onClick={() => {
                                    getEstimateExpirationDate(quantity, unit);
                                    setOpenDialog(true);
                                }}>Renew</Button>

                                {/* <div className={`flex flex-row gap-2 ${!update && 'hidden'}`}>
                                    <button onClick={() => startEdit('')} className="inline-flex min-h-[38px] items-center rounded-xl bg-white px-4 text-sm font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50">Cancel</button>
                                    <button onClick={() => { }} className="inline-flex min-h-[38px] items-center rounded-xl bg-gradient-to-b from-emerald-500 to-emerald-600 px-4 text-sm font-bold text-white shadow-lg shadow-emerald-600/25 transition hover:from-emerald-600 hover:to-emerald-700">Save</button>
                                </div> */}

                            </div>

                        </div>

                    </div>

                    </Layout>

            <Dialog open={openDialog} onClose={() => {
                if (!renewLoading) {
                    setOpenDialog(false);
                }
            }} className="relative z-[60]">
                <DialogBackdrop transition className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in" />
                <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
                    <div className="flex min-h-full justify-center p-4 text-center items-start sm:items-center">
                        <DialogPanel
                            transition
                            className="thin-scroll w-full sm:w-[560px] max-h-[88vh] overflow-y-auto p-6 sm:p-7 relative transform rounded-2xl border border-slate-200 bg-white text-left shadow-2xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                        >

                            <h2 className="text-lg font-semibold tracking-tight text-slate-900">Renew subscription</h2>
                            <p className="mt-1 text-sm text-slate-500">Extend the expiry of this remote account.</p>

                            <div className="mt-5 rounded-xl bg-slate-50 p-4 ring-1 ring-slate-200">
                                <div className="flex items-start justify-between gap-4 text-sm">
                                    <span className="text-slate-500">Current expiry</span>
                                    <span className="text-right font-semibold text-slate-800">{getExpiration()}</span>
                                </div>
                                <div className="mt-2 flex items-start justify-between gap-4 text-sm">
                                    <span className="text-slate-500">New expiry</span>
                                    <span className="text-right font-bold text-emerald-600">{expiration}</span>
                                </div>
                            </div>

                            <hr className='my-5 border-slate-100' />

                            <div className="mb-5">

                                <h3 className="text-sm font-bold uppercase tracking-wider text-slate-400">Subscription Plan</h3>
                                <div className={`text-red-500 italic text-xs ${!subsReq && 'hidden'}`}>* Please add subscription plan</div>

                                <div className='ml-5 mt-3 flex flex-row items-center gap-3'>
                                    <input
                                        type="number"
                                        min={1}
                                        value={quantity}
                                        style={{ width: "100px", height: '40px' }}
                                        disabled={renewLoading}
                                        aria-describedby="helper-text-explanation"
                                        className="px-3 py-1 border-[1px] border-gray-300 text-sm rounded-md focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50"
                                        onChange={(e) => {
                                            if (e.target.value === '0') return;
                                            setQuantity(e.target.value);
                                            getEstimateExpirationDate(e.target.value, unit);
                                            if (unit) {
                                                setSubsReq(false);
                                            }
                                        }}
                                    />
                                    <select
                                        value={unit}
                                        style={{ width: "150px", height: '40px' }}
                                        disabled={renewLoading}
                                        className={`px-2 py-1 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-50`}
                                        onChange={(e) => {
                                            setUnit(e.target.value);
                                            getEstimateExpirationDate(quantity, e.target.value);
                                            if (quantity) {
                                                setSubsReq(false);
                                            }
                                        }}>
                                        <option disabled={true}>Please select...</option>
                                        <option value='month'>Month{parseInt(quantity) > 1 ? 's' : ''}</option>
                                        <option value='year'>Year{parseInt(quantity) > 1 ? 's' : ''}</option>
                                    </select>
                                </div>

                            </div>

                            <hr className='my-5 border-slate-100' />

                            <div className="mb-5">
                                <h3 className="mb-3 text-sm font-bold uppercase tracking-wider text-slate-400">Pay with Credits</h3>

                                <CreditsPayment price={price()} balance={balance} error={balanceError} />

                                <div className='mt-3 text-xs'>A confirmation receipt will be sent to <span className='font-bold'>{window.localStorage['email']}</span></div>
                            </div>

                            <hr className='mt-5 mb-1 border-slate-100' />

                            <div>
                                <div className={`w-full text-center px-5 ${(!renewError) && 'hidden'}`}>
                                    <div className='text-red-500 italic text-sm'><div dangerouslySetInnerHTML={{ __html: renewError }} /></div>
                                </div>
                            </div>

                            <div className="mt-5 flex flex-row gap-2">
                                <div className="grow"></div>
                                <button disabled={renewLoading} onClick={() => setOpenDialog(false)} className='inline-flex min-h-[40px] items-center rounded-full bg-white px-5 text-sm font-semibold text-slate-700 ring-1 ring-inset ring-slate-200 transition hover:bg-slate-50'>Cancel</button>

                                <button disabled={renewLoading} onClick={submit} className='inline-flex min-h-[40px] items-center gap-2 rounded-full bg-emerald-600 px-5 text-sm font-bold text-white transition hover:bg-slate-950 disabled:bg-slate-300'>{renewLoading && <Spinner className='inline mr-2' />}Submit</button>
                            </div>

                        </DialogPanel>
                    </div>

                </div>

            </Dialog>

            <ConfirmDialog open={confirmDialog} setDialog={setConfirmDialog} onClickYes={renew} />



        </>
    )
}


function ConfirmDialog({ open, setDialog, onClickYes }: any) {
    return (<Dialog open={open ?? false} onClose={setDialog} className="relative z-[60]">
        <DialogBackdrop
            transition
            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />

        <div className="fixed inset-0 z-[60] w-screen overflow-y-auto">
            <div className="flex min-h-full items-center justify-center text-center p-0">
                <DialogPanel
                    transition
                    className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                >
                    <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                        <div className="sm:flex sm:items-start">

                            <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-blue-200 sm:mx-0 sm:h-10 sm:w-10`}>
                                <FaQuestion aria-hidden="true" className="h-6 w-6 text-blue-700" />
                            </div>

                            <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                                <DialogTitle as="h3" className="text-base font-semibold leading-6 text-gray-900">Confirm Subscription Renewal</DialogTitle>
                                <div className="mt-2">
                                    <div className="text-sm text-gray-700"><div dangerouslySetInnerHTML={{ __html: 'Please review your subscription renewal and payment details. If everything is correct, click "Yes" to complete your renewal. To make changes or cancel, click "No."' }} /></div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="bg-gray-50 px-4 py-3 flex flex-row gap-3">
                        <div className='grow'></div>

                        <div className={`flex flex-row gap-3`}>
                            <button
                                className='disabled:bg-gray-500 w-[80px] flex flex-row items-center justify-center bg-blue-600 px-3 py-1 text-sm font-medium rounded-md text-white shadow-sm hover:bg-blue-500 active:bg-blue-700'
                                onClick={() => {
                                    setDialog(false);
                                    onClickYes && onClickYes();
                                }}>Yes</button>
                            <button
                                type="button"
                                data-autofocus
                                onClick={() => setDialog(false)}
                                className="disabled:bg-gray-500 inline-flex w-[80px] justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50"
                            >No</button>
                        </div>

                    </div>
                </DialogPanel>
            </div>
        </div>
    </Dialog>)
}

function Small({ items }: any) {

    if (!items?.length) {
        return <div className="py-6 text-center text-sm text-gray-500">No transactions yet.</div>
    }

    return (<ul className="flex flex-col gap-3">
        {items?.map((item: any, index: number) => {

            const date = item.date ? moment(item.date).format('YYYY-MM-DD hh:mm a') : '';

            return <li key={`${index}-ref`} className="flex flex-col gap-2 rounded-xl bg-gray-50 p-3 ring-1 ring-gray-200">

                <div className="flex flex-row items-center gap-2">
                    <span className="rounded-full bg-blue-50 px-2 py-0.5 text-[11px] font-semibold text-blue-700 ring-1 ring-inset ring-blue-200">
                        {item.action?.toUpperCase()}
                    </span>
                    <span className="grow text-right text-xs text-gray-500">{date}</span>
                </div>

                <a href={`/transaction/${item.transaction_id}`} className="break-all text-xs font-medium text-blue-600 hover:underline">
                    {item.transaction_id}
                </a>

                <div className="text-xs text-gray-500">
                    Plan: <span className="font-semibold text-gray-900">{item.quantity} {item.unit}{parseInt(item.quantity) > 1 ? 's' : ''}</span>
                </div>

            </li>
        })}
    </ul>)
}


function Large({ items }: any) {

    if (!items?.length) {
        return <div className="py-6 text-center text-sm text-gray-500">No transactions yet.</div>
    }

    return (<div className="overflow-x-auto rounded-xl ring-1 ring-gray-200">
        <table className="w-full min-w-[640px] divide-y divide-gray-200 text-left">
            <thead className="bg-slate-50/80 text-[11px] uppercase tracking-[0.08em] text-slate-500">
                <tr>
                    <th className="px-4 py-2.5 font-semibold w-[190px]">Date</th>
                    <th className="px-4 py-2.5 font-semibold w-[110px]">Action</th>
                    <th className="px-4 py-2.5 font-semibold">Transaction Id</th>
                    <th className="px-4 py-2.5 font-semibold w-[90px] text-center">Qty</th>
                    <th className="px-4 py-2.5 font-semibold w-[90px]">Unit</th>
                </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
                {items?.map((item: any, index: number) => {

                    const date = item.date ? moment(item.date).format('YYYY-MM-DD hh:mm a') : '';

                    return <tr key={`${index}-ref`} className="transition hover:bg-blue-50/50">
                        <td className="whitespace-nowrap px-4 py-2.5 text-sm text-gray-600">{date}</td>
                        <td className="whitespace-nowrap px-4 py-2.5 text-sm font-medium text-gray-700">{item.action?.toUpperCase()}</td>
                        <td className="whitespace-nowrap px-4 py-2.5 text-sm">
                            <a href={`/transaction/${item.transaction_id}`} className="font-medium text-blue-600 hover:underline">{item.transaction_id}</a>
                        </td>
                        <td className="whitespace-nowrap px-4 py-2.5 text-sm text-center text-gray-600">{item.quantity}</td>
                        <td className="whitespace-nowrap px-4 py-2.5 text-sm text-gray-600">{item.unit}</td>
                    </tr>
                })}
            </tbody>
        </table>
    </div>);

}
